// extracted by mini-css-extract-plugin
export default {"italics":"wrapCVIReviewWidget_italics__lOH2n","value":"wrapCVIReviewWidget_value__3oVMx"};